import React from 'react'
import { ToastProvider } from './components/Toast'

/**
 * Shared root wrapper used by both gatsby-browser.js and gatsby-ssr.js so a
 * single centralized <ToastProvider> hosts toast notifications for every page
 * and dialog in the app.
 */
export const wrapRootElement = ({ element }) => (
  <ToastProvider>{element}</ToastProvider>
)

export default wrapRootElement
